import { render, staticRenderFns } from "./tiktok-view.vue?vue&type=template&id=b6a39d48&scoped=true&"
import script from "./tiktok-view.vue?vue&type=script&lang=js&"
export * from "./tiktok-view.vue?vue&type=script&lang=js&"
import style0 from "./tiktok-view.vue?vue&type=style&index=0&id=b6a39d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a39d48",
  null
  
)

export default component.exports